import { serialize } from 'next-mdx-remote/serialize';

import PageWrapper from 'components/PageWrapper';
import StaticPage from 'components/StaticPage';

import { getLocations } from 'utils/graphcms/queries/locations';
import {
  getStaticPage,
  getStaticPages,
} from 'utils/graphcms/queries/staticPage';

export default function GenericPage({ page }) {
  return (
    <PageWrapper page={page}>
      <StaticPage page={page} />
    </PageWrapper>
  );
}

export async function getStaticProps({ params: { slug } }) {
  const page = await getStaticPage(slug);
  return {
    props: {
      page: {
        markdown: page.content ? await serialize(page.content) : null,
        ...page,
      },
    },
  };
}

export async function getStaticPaths() {
  const slugs = await getStaticPages();
  const locations = await getLocations();
  return {
    paths: locations
      .map((location) => slugs.map((slug) => ({ params: { location, slug } })))
      .flat(),
    fallback: false,
  };
}
